import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="nav">
      <div className="container nav-inner">
        <Link to={user ? '/dashboard' : '/'} className="brand">
          <img src="/logo.svg" alt="" />
          <span>PMP <b>Revise</b></span>
        </Link>
        <div className="nav-links">
          {!user && (
            <>
              <Link to="/terms" className="btn btn-ghost btn-sm">Terms</Link>
              <Link to="/login" className="btn btn-ghost btn-sm">Sign in</Link>
              <Link to="/register" className="btn btn-primary btn-sm">Get started</Link>
            </>
          )}
          {user && (
            <>
              <Link to="/dashboard" className="btn btn-ghost btn-sm">Assistant</Link>
              <Link to="/mock-exams" className="btn btn-ghost btn-sm">Mock exams</Link>
              <Link to="/progress" className="btn btn-ghost btn-sm">Progress</Link>
              {(user.role === 'admin' || user.role === 'superadmin') && (
                <Link to="/admin" className="btn btn-ghost btn-sm">Admin</Link>
              )}
              <button className="btn btn-ghost btn-sm" onClick={doLogout}>Sign out</button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
